<template>
  <div class="setting">
    <van-nav-bar
      title="设置"
      left-text
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="content">
      <div class="cell-group">
        <van-cell title="当前版本" class="bottom-cell" :value="vesion" />
        <van-cell
          title="手机号"
          is-link
          :value="phone"
          class="bottom-cell"
          to="replacePhone"
        />
        <van-cell
          title="登录密码"
          is-link
          value="修改"
          class="bottom-cell"
          to="changePassword"
        />
        <van-cell
          title="我的收货地址"
          is-link
          class="bottom-cell"
          to="adressList"
        />
        <van-cell
          title="用户使用协议"
          is-link
          class="bottom-cell"
          to="informedConsent"
        />
        <!-- <van-cell title="隐私管理" is-link class="bottom-cell" to="privacyManagement" /> -->
        <van-cell
          title="隐私政策"
          is-link
          class="bottom-cell"
          to="privacyAgreement"
        />
        <van-cell title="注销账户" is-link class="bottom-cell" to="cancel" />
      </div>
      <div class="setting_logout">
        <button class="setting_logout_button" @click="logoutUser">
          退出登录
        </button>
      </div>
    </div>
    <modal btnType="2" ref="modalGrow" @submit="sure" @cancel="cancel">
      <template v-slot:body>
        <p>您确定要退出账号吗？</p>
      </template>
    </modal>
  </div>
</template>
<script>
import { _loginOut } from "../../api/setting";
import Modal from "../../components/common/modal.vue";
import Cookies from "js-cookie";
import { verticalScreen } from "../../assets/js/vertical-screen";
import { decryptBy } from "@/assets/js/encryption";
export default {
  components: {
    Modal,
  },
  name: "setting",
  data() {
    return {
      vesion: "1.1.0",
      phone: "",
    };
  },
  mounted() {
    let info = localStorage.getItem("userInfo");
    let user = JSON.parse(decryptBy(info));
    let phone = decryptBy(user.mobilePhone);

    this.phone = `${phone.substring(0, 3)}****${phone.substring(
      7,
      phone.length
    )}`;
    verticalScreen();
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    //退出登录
    logoutUser() {
      this.$refs.modalGrow.openDialog();
      sessionStorage.clear();
    },
    // 确认退出
    sure() {
      _loginOut({
        authentication: Cookies.get("token"),
      }).then((res) => {
        if (res.code == 200) {
          Cookies.remove("token");
          localStorage.removeItem("childId");
          localStorage.removeItem("children");
          // this.$router.push("/login");
          window.location.href = "/#/login";
          localStorage.clear();
          this.cancel();
          // 视频播放中有一个记录用户是否同意播放不限制流量的标识，退出i清空
          localStorage.removeItem("wifiAccept");
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 取消退出
    cancel() {
      this.$refs.modalGrow.closeDialog();
    },
  },
};
</script>
<style lang="less" scoped>
.setting {
  position: relative;
  height: 100%;
  background: #f5f7fa url(../../assets/images/setting/bg.png) no-repeat left
    top/100% 311px;
  .content {
    background: #fff;
    margin: 8px 20px 0;
    padding-bottom: 30px;
  }
  .cell-group {
    /deep/.van-cell {
      padding: 14px 20px;
    }
  }
  .setting_logout {
    // position: fixed;
    margin-top: 140px;
    text-align: center;
    // bottom: 68px;
    .setting_logout_button {
      width: 295px;
      height: 40px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 23px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 40px;
      // margin-left: 54.5px;
    }
  }
  ::v-deep .van-icon {
    color: #000;
  }
}
</style>
